export function exactlyOneElement(arr) {
    return !!arr && arr.length === 1;
}
export function atLeastOneElement(arr) {
    return !!arr && arr.length > 0;
}
//# sourceMappingURL=array_utils.js.map